import { useCallback, useMemo } from 'react';
import history from '../history';
import { getUrlStateParams } from './utils';
import { DEFAULT_PAGINATION_ROWS_COUNT } from '../constants/pagination';
import mixpanel from 'mixpanel-browser';
import mixpanelEvents from '../mixpanelEvents';

const DECIMAL_RADIX = 10;
const defaultPage = 1;
const defaultRowLimit = DEFAULT_PAGINATION_ROWS_COUNT;

const usePaginationFilter = dataLength => {
  const search = history?.location?.search;

  const currentPageFromURL = useMemo(() => {
    let page = getUrlStateParams(history, 'page', []);

    return page.length ? parseInt(page[0], DECIMAL_RADIX) : defaultPage;
  }, [search]);

  const rowLimitFromURL = useMemo(() => {
    let rowLimit = getUrlStateParams(history, 'rowLimit', []);

    return rowLimit.length
      ? parseInt(rowLimit[0], DECIMAL_RADIX)
      : defaultRowLimit;
  }, [search]);

  const setPagination = useCallback(
    (newPage, newRowLimit) => {
      const targetRowLimit =
        newRowLimit !== undefined ? newRowLimit : rowLimitFromURL;

      mixpanel?.track(mixpanelEvents.FILTER_APPLIED, {
        type: 'Pagination',
        page: newPage,
        rowLimit: targetRowLimit,
        dataLength,
      });

      setPaginationAndUpdateUrl(newPage, targetRowLimit, dataLength);
    },
    [currentPageFromURL, rowLimitFromURL, dataLength]
  );

  return {
    currentPage: currentPageFromURL,
    rowLimit: rowLimitFromURL,
    setPagination,
  };
};

export default usePaginationFilter;

const setPaginationAndUpdateUrl = (page, rowLimit, dataLength) => {
  const pathname = history?.location?.pathname;
  const updatedSearchParams = new URLSearchParams(history?.location?.search);

  updatedSearchParams.set('page', page.toString());
  if (rowLimit !== undefined) {
    updatedSearchParams.set('rowLimit', rowLimit.toString());
  }

  const newUrl = `${pathname}?${updatedSearchParams.toString()}`;

  if (newUrl !== window.location.href && dataLength <= rowLimit) {
    history?.replace({ pathname, search: updatedSearchParams.toString() });
  } else if (newUrl !== window.location.href) {
    history?.push({ pathname, search: updatedSearchParams.toString() });
  }
};
